/**
 * Die leise Zeile unter dem Betreff (Zeichnung 10.09.2026: „Angelegt Fr, 05.09
 * · Mohamed · zuletzt bearbeitet"). Reine Ableitung, damit sie ohne DOM prüfbar
 * ist — sie besteht aus lauter Teilen, die fehlen dürfen, und genau daran
 * gehen solche Zeilen sonst kaputt (»· · von null«).
 *
 * Die Vorgangsnummer steht hier, weil V4 die Eyebrow-Zeile von V3 nicht mehr
 * hat: In der Zeichnung kommt sie nicht vor, verloren gehen darf sie trotzdem
 * nicht — sie ist die Nummer, die am Telefon genannt wird.
 *
 * `jetzt` ist injizierbar, damit der Test nicht am Kalender hängt.
 */

export type KopfMetaArgs = {
    /** Fachliche Vorgangsnummer; fehlt sie, tritt die technische Id ein. */
    nummer?: string | null;
    id?: number | null;
    /** Anlagezeitpunkt (ISO). */
    angelegt?: string | null;
    /** Aufgelöster Name des Erstellers. */
    ersteller?: string | null;
    /** Jüngste Aktivität — letzte Notiz oder letztes Ereignis. */
    zuletzt?: Date | null;
};

/** Tag mit Wochentag; das Jahr nur, wenn es nicht das laufende ist. */
export function tagKurz(d: Date, jetzt: Date = new Date()): string {
    const basis = d.toLocaleDateString("de-DE", {
        weekday: "short",
        day: "2-digit",
        month: "2-digit",
    });
    return d.getFullYear() === jetzt.getFullYear() ? basis : `${basis}${d.getFullYear()}`;
}

const gueltig = (iso?: string | null): Date | null => {
    if (!iso) return null;
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) || d.getTime() === 0 ? null : d;
};

export function kopfMeta(args: KopfMetaArgs, jetzt: Date = new Date()): string {
    const teile: string[] = [];

    const nummer = args.nummer?.trim();
    if (nummer) teile.push(nummer);
    else if (args.id != null) teile.push(`Vorgang ${args.id}`);

    const angelegt = gueltig(args.angelegt);
    const wer = args.ersteller?.trim();
    if (angelegt) teile.push(wer ? `angelegt ${tagKurz(angelegt, jetzt)} von ${wer}` : `angelegt ${tagKurz(angelegt, jetzt)}`);
    else if (wer) teile.push(`angelegt von ${wer}`);

    const zuletzt = args.zuletzt;
    // Nur zeigen, wenn seit der Anlage wirklich etwas passiert ist — sonst
    // stünde „zuletzt bearbeitet“ auf demselben Zeitpunkt wie „angelegt“ und
    // behauptete eine Bearbeitung, die es nicht gab.
    if (zuletzt && !Number.isNaN(zuletzt.getTime()) && zuletzt.getTime() > 0
        && (!angelegt || zuletzt.getTime() > angelegt.getTime())) {
        const uhr = zuletzt.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });
        teile.push(`zuletzt bearbeitet ${tagKurz(zuletzt, jetzt)}, ${uhr}`);
    }

    return teile.join(" · ");
}
